import { useQuery } from '@tanstack/react-query';

import { fetchFreeListings, fetchPremiumListings } from 'hooks/useDirectoryData/fetchListings';

import type { ListingDetail, ListingKind } from '../../types';

// A world-covering box returns every listing, which is then filtered client-side by id (no per-id endpoint exists).
const WORLD_BOUNDS = { lat1: 90, lat2: -90, lon1: 180, lon2: -180 };

function getQueryKey(id: string, kind: ListingKind, appId: string, table: string) {
  return ['directoryListingDetail', kind, appId, table, id] as const;
}

function getQueryFn(id: string, kind: ListingKind, appId: string, table: string) {
  return async (): Promise<ListingDetail | null> => {
    if (kind === 'free') {
      const results = await fetchFreeListings(appId, WORLD_BOUNDS, table, '', '', '', false);

      const match = results.find((item) => {
        return item.listing_id.toString() === id || item.company_listing_id.toString() === id;
      });
      return match ? { ...match, kind: 'free' } : null;
    }

    const items = await fetchPremiumListings(appId, WORLD_BOUNDS, '', '', true, true, false);

    const match = items.find((item) => {
      return item.userInfoID === id;
    });
    return match ? { ...match, kind: 'premium' } : null;
  };
}

export function useListingDetail(id: string, kind: ListingKind, appId: string, table: string) {
  return useQuery({
    queryKey: getQueryKey(id, kind, appId, table),
    queryFn: getQueryFn(id, kind, appId, table),
    enabled: Boolean(id && appId && table),
  });
}
